<template>
  <div class="full-width full-height dynamic-form q-pa-md">
    <div class="row q-pa-md q-py-sm q-col-gutter-x-lg q-col-gutter-y-xs">
      <div
        v-for="(input, index) in elInputs"
        :key="index"
        class="q-field__inner"
        :class="
          input.columnsSize
            ? 'col-' + input.columnsSize
            : !input.columnsPerLine
            ? 'col-12'
            : 'col-md-' + 12 / input.columnsPerLine
        "
      >
        <jt-text-input
          :key="index"
          :input="input"
          :value="input.value || forms[0].dadosForm[input.model]"
          :readonly="true"
          :disable="true"
          :stack-label="input.label"
          :float-label="input.label"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtTextInput } from 'jtech-webcomps'

import { remove } from 'mobx'
@Component({
  components: {
    JtTextInput
  },
  props: {
    forms: {},
    title: String
  }
})
class ClientCharge extends Vue {
  formModel = {};

  mounted () {
    this.forms[0].inputs = this.forms[0].inputs.filter(
      (i) => i.type != 'COMPOSICAO'
    )
    this.formModel = this.forms[0].dadosForm
  }

  get elInputs () {
    return [...this.inputs, ...this.phones, ...this.emails]
  }

  get inputs () {
    this.forms[0].inputs = this.forms[0].inputs.filter(
      (i) => i.type != 'COMPOSICAO'
    )
    return this.forms[0].inputs
  }

  get emails () {
    return this.formModel?.contactPersonEmails?.map(email => ({
      value: email,
      label: this.$gettext('EMAIL'),
      columnsSize: 3
    })) || []
  }

  get phones () {
    if (!this.formModel?.contactPersonPhones) {
      return []
    }

    return this.formModel.contactPersonPhones.map(phone => ({
      value: phone,
      label: this.$gettext('PHONE'),
      columnsSize: 3
    }))
  }
}
export default ClientCharge
</script>
<style lang="stylus" scoped>
</style>
